import { render, staticRenderFns } from "./IntegrationsNav.vue?vue&type=template&id=64416b5d&scoped=true&"
import script from "./IntegrationsNav.vue?vue&type=script&lang=js&"
export * from "./IntegrationsNav.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsNav.vue?vue&type=style&index=0&id=64416b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64416b5d",
  null
  
)

export default component.exports